import * as React from 'react';
import {Context} from '../../state/Store';
import Button from '../../common/Button/Button';
import RedwoodCheckbox from "../../common/Checkbox/RedwoodCheckbox";
import * as _ from 'lodash';
import './AgreementComponent.css';
import {useTranslation, Trans} from "react-i18next";
import RedwoodModal from '../../common/Modal/RedwoodModal';
import SendAction from '../../CourierService/SendAction';
import SendLogs from '../../CourierService/SendLogs';
import OrgNameList from '../../data/orgNames.json';
import SendMetrics from '../../CourierService/SendMetrics';
import {randomPaddedIntString} from '../Helpers';
import {navTrack} from '../../config/adobeAnalytics';
import {removeSpace} from './../../components/Helpers';
import {fetchCreateAccount} from "../../CourierService/FetchService";


const AgreementComponent = (props) => {
  const [state, dispatch] = React.useContext(Context);
  const [show, setShow] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const shortMonths = ['','JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  const {t} = useTranslation();
  const {createAccountStatus, updateCreateAccountStatus, checkbox, updateCheckbox, toggleCallback} = props;
  const [createAccountRetries, setCreateAccountRetries] = React.useState(0);

  const setCreditCardType = (cardType) => {
    if(cardType === 'DINER') {
      return 'DINERS';
    } else {
      return state.paymentOptions.creditCardType;
    }
  }

  const setApiError = () => {
    dispatch({
      type:'UPDATE_APIERROR',
      payload: true
    });
  };

  const sourceType = () => {
    let sourceType = '';
    if(state.sourceType !== '') {
      sourceType = state.sourceType;
    }
    if(!_.isEmpty(sourceType) && !_.isEmpty(state.selectedPromo.campaignId)) {
      sourceType = state.sourceType + '-campaignId-' + state.selectedPromo.campaignId
    } else if(!_.isEmpty(state.selectedPromo.campaignId)) {
      sourceType = 'campaignId-' + state.selectedPromo.campaignId;
    }
    return sourceType;
  }

  const randomNumber = randomPaddedIntString(0, 999999, "0", 6);
  let name = state.username + '-' + state.companyName + `${state.companyName === '' ? '': '-'}` + randomNumber; //emailWithRandomNumber
  let organization = state.companyName === '' ? name : state.companyName; //orgName
  organization = organization.replace(/\s+/g, " ");

  const getCustomerName = () => {
    let customerName = ''
    if(state.country === 'BR' && state.intendedUse === 'PERSONAL') {
      customerName = state.firstName + ' ' + state.lastName
    }
    else if(!_.isEmpty(state.selectedPromo) && state.selectedPromo.customerName !== '') {
      customerName = state.selectedPromo.customerName
    }
    else if(!_.isEmpty(state.selectedPromo) && state.selectedPromo.programType === 'SE-TRIAL') {
      customerName = state.companyName;
    } else if((state.intendedUse === 'COMPANY' || _.toUpper(state.selectedPromo.intendedUse) === 'ENTERPRISE') && state.country === 'BR'){
      customerName = organization;
    } else {
      customerName = name;
    }
    return customerName;
    
  };

  const getAltCustomerName = () => {
    let altName = name;
    const altCustomerName = altName.replace(/[^\x20-\x7E]+/g, '');
    return altCustomerName;

  }

  const getCloudUICustomerName = () => {
    let cloudUICustomerName = ''
    if(!_.isEmpty(state.selectedPromo) && state.selectedPromo.customerName !== '') {
      cloudUICustomerName = state.selectedPromo.customerName;
    }
    else if(state.intendedUse === 'PERSONAL') {
      cloudUICustomerName = state.accountName;
    } else {
      cloudUICustomerName = state.username + '-' + state.companyName + '-' + randomNumber;
    }
    return cloudUICustomerName;

  }

  const getCloudUIAltCustomerName = () => {
    let cloudUIAltCustomerName = ''
    if(!_.isEmpty(state.selectedPromo) && state.selectedPromo.customerName !== '') {
      cloudUIAltCustomerName = state.selectedPromo.customerName;
    } else {
      cloudUIAltCustomerName = state.accountName;
    }
    return cloudUIAltCustomerName;
  }

  const setOperationItemDefinition = () => {
   let operationId =  _.isEmpty(state.selectedPromo) ? state.defaultPromo.id : state.selectedPromo.id;
   if(!_.isEmpty(state.paymentOptions) && state.paymentOptions.paymentMethod === 'PAYPAL' && (state.country === 'MX' || state.country === 'NZ')) {
    operationId = "OIH-PROMOCM-PAYPAL-CREATE_V2"
   }
   return operationId
  }

  const CreateAccountDetails = {
    "operationItemDefinition": setOperationItemDefinition(),
    "individualCustomer": state.companyName === "" ? 'Y' : 'N',
    "promotionIntendedUse": _.isEmpty(state.selectedPromo) || _.isEmpty(state.selectedPromo.intendedUse)? 'PERSONAL' : state.companyName !== '' ? 'ENTERPRISE': _.toUpper(state.selectedPromo.intendedUse),
    "promotionGuestId": _.isEmpty(state.selectedPromo) ? "" : _.isEmpty(state.selectedPromo.promoId) ? '' : state.selectedPromo.promoId,
    "intendedUse": state.companyName === '' ? 'PERSONAL' : 'COMPANY',
    "customerName": _.isEmpty(getCustomerName()) ? name : getCustomerName(),
    "alternateCustomerName": getAltCustomerName(),
    "cloudUICustomerName": getCloudUICustomerName(),
    "cloudUIAlternateCustomerName": getCloudUIAltCustomerName(),
    "cloudAccountName" : state.accountName,
    "dataRegion": state.homeRegion.group,
    "homeRegion": state.homeRegion.value.id,
    "country": state.country,
    "address1": state.address.address1,
    "address2": state.address.address2,
    "address3": state.address.address3,
    "address4": state.address.address4,
    "city": state.address.city,
    "postalCode": state.address.postalcode,
    "state": _.isEmpty(state.address.selectedState) ? state.address.state : _.split(state.address.selectedState.value.id, '-', 2)[1],
    "province": state.address.province,
    "county": state.address.county,
    "userName": state.username,
    "emailAddress": state.username,
    "firstName": state.firstName,
    "lastName": state.lastName,
    "departmentName": state.departmentName,
    "jobTitle": state.jobTitle,
    "phoneNumber": state.phoneNumber,
    "adminFirstName": state.firstName,
    "adminLastName": state.lastName,
    "adminEmail": state.username,
    "adminUserName": state.username,
    "validationSmsNumber": state.phoneNumber,
    "validationCode": state.verificationCode,
    "validationSmsEmail": state.username,
    "miniBobEnabled": state.miniBobEnabled,
    "adminPassword": state.password,
    "taxPayerId": "",
    "taxRegNumber": "",
    "taxCNPJ": state.country === "BR" ? state.taxPayerId : "",
    "billingTaxCNPJ": "",
    "noTaxReasonCode": "",
    "noTaxReasonCodeDetails": "",
    "cloudUISourceType": sourceType(),
    "cloudUIReferrer": '',
    "billingDepartmentName": _.isEmpty(state.billingAddress) ? "" : state.billingAddress.departmentName,
    "billingAddress1": _.isEmpty(state.billingAddress) ? "" : state.billingAddress.line1 === ' ' ? state.address.address1 : state.billingAddress.line1,
    "billingAddress2": _.isEmpty(state.billingAddress) ? "" : state.billingAddress.line2 === ' ' ? state.address.address2 : state.billingAddress.line2,
    "billingAddress3": _.isEmpty(state.billingAddress) ? "" : state.billingAddress.line3 === ' ' ? state.address.address3 : state.billingAddress.line3,
    "billingAddress4": _.isEmpty(state.billingAddress) ? "" : state.billingAddress.line4 === ' ' ? state.address.address4 : state.billingAddress.line4,
    "billingCity": _.isEmpty(state.billingAddress) ? "" : state.billingAddress.city === ' ' ? state.address.city : state.billingAddress.city,
    "billingState": _.isEmpty(state.billingAddress) ? "" : state.billingAddress.state === ' ' ? state.address.state : state.billingAddress.state,
    "billingCounty": _.isEmpty(state.billingAddress) ? "" : state.billingAddress.county === ' ' ? state.address.county : state.billingAddress.county,
    "billingProvince": _.isEmpty(state.billingAddress) ? "" : state.billingAddress.province === ' ' ? state.address.province : state.billingAddress.province,
    "billingPostalCode": _.isEmpty(state.billingAddress) ? "" : state.billingAddress.postalCode === ' ' ? state.address.postalcode : state.billingAddress.postalCode,
    "billingFirstName": _.isEmpty(state.billingAddress) ? "" : state.billingAddress.firstName,
    "billingLastName": _.isEmpty(state.billingAddress) ? "" : state.billingAddress.lastName,
    "billingPhoneNumber": _.isEmpty(state.billingAddress) ? "" : state.billingAddress.phoneNumber,
    "billingEmailAddress": _.isEmpty(state.billingAddress) ? "" : state.billingAddress.emailAddress,
    "creditCardFirstName": _.isEmpty(state.paymentOptions) ? "" : state.paymentOptions.creditCardFirstName,
    "creditCardLastName": _.isEmpty(state.paymentOptions) ? "" : state.paymentOptions.creditCardLastName,
    "creditCardLastFourDigits":  _.isEmpty(state.paymentOptions) ? "" : state.paymentOptions.creditCardLastDigits,
    "creditCardType": _.isEmpty(state.paymentOptions) ? "" : setCreditCardType(state.paymentOptions.creditCardType),
    "paymentResponse": state.paymentResponse,
    "creditCardPaymentToken": "",
    "creditCardExpirationMonth": _.isEmpty(state.paymentOptions) ? "" : shortMonths[Number(_.split(state.paymentOptions.creditCardExpirationDate, '-', 2)[1])],
    "creditCardExpirationYear": _.isEmpty(state.paymentOptions) ? "" : _.split(state.paymentOptions.creditCardExpirationDate, '-', 2)[0],
    "billingCountry": _.isEmpty(state.billingAddress) ? "" : state.billingAddress.country,
    "apiaryId": _.isEmpty(state.apiaryId) ? "" : state.apiaryId,
    "verificationToken": _.isEmpty(state.emailToken) ? '' : state.emailToken,
    "paypalId": _.isEmpty(state.paymentOptions) && _.isEmpty(state.paymentOptions.paypalId) ? "" : state.paymentOptions.paypalId,
    "paymentTransactionType": _.isEmpty(state.paymentOptions)  ? "" : state.paymentOptions.paymentMethod
  }

  const toggleModal = () => {
    setShow(!show);
    SendAction({action:'POST createAccount API failed', value: 'Error Dialog Pop-up displayed', userSession: state.user_session});
    //Add class to body for overlay
    toggleCallback();
  }

  const closeModal = () => {
    setShow(!show);
    window.location.reload();
    SendAction({action:'POST createAccount API failed', value: 'Reload signup page', userSession: state.user_session});
    //Add class to body for overlay
    toggleCallback();
  }

  React.useEffect(() => {
    if(createAccountStatus.createAccountApi) {
      setLoading(true);
      const start = new Date();
      fetchCreateAccount(encodeURIComponent(state.username),JSON.stringify(removeSpace(CreateAccountDetails)))
          .then(async res => {
            SendMetrics({name:"CreateAccount.Latency", value: new Date() - start, userSession:state.user_session});

            setLoading(false);
            if(res.status === 201) {
              const result = await res.json();
              updateCheckbox(false);
              const status = _.isEmpty(result.status) ? '' : result.status;
              if(status === 'REVIEW') {
                SendLogs({severity: '20000', message: 'Create Account Status: Review, EmailID:'+state.username, userSession: state.user_session});
                SendMetrics({name:"CreateAccount.Count.Metrics.Review", value:1, userSession:state.user_session});
                navTrack('oci-signup', state.language, 's2-received-fraud-status', 'REVIEW-status-flagged-by-OCIAF');
              } else {
                SendLogs({severity: '20000', message: 'Create Account Status: Accepted, EmailID:'+state.username, userSession: state.user_session});
                if(state.operationId === 'OIH-PROMOCM-UNIVERSAL-CREDITS-VIRTUAL-STARTUP-CREATE' && _.isEmpty(state.promoId)) {
                  navTrack('oci-signup', state.language, 'signup-account-created', 'Internal-oracle-employees');
                  SendLogs({severity: '20000', message: 'signup-account-created-INTERNAL-oracle-employees, EmailID:'+state.username, userSession: state.user_session});
                } else {
                  navTrack('oci-signup', state.language, 'signup-account-created', 'External-customers');
                  SendLogs({severity: '20000', message: 'signup-account-created-EXTERNAL-customers, EmailID:'+state.username, userSession: state.user_session});
                }
                SendMetrics({name:"CreateAccount.Count.Metrics.Accept", value:1, userSession:state.user_session});
              }
              dispatch({type: 'OPERATION_ID', payload: [result.operationId, status]});
              SendLogs({severity: '20000', message: 'POST createAccount API successful: ' + JSON.stringify(result) + 'EmailID:'+state.username, userSession: state.user_session});
            }
            if(res.status === 400) {
              const result = await res.json();
              if(result.paymentGatewayAuthReasonCode) {
                navTrack('oci-signup', state.language, 's2-received-fraud-status', 'REJECT-status-by-cybersource');
                dispatch({type: 'PAYMENT_ERROR', payload: result});
                updateCheckbox(true);
                updateCreateAccountStatus(!(createAccountStatus.checked), false)
                SendLogs({severity: '40000', message: 'Fraud Response: ' + result.paymentGatewayAuthReasonCode + 'EmailID:'+state.username, userSession: state.user_session});
                SendMetrics({name:"CreateAccount.Count.Metrics.Reject", value:1, userSession:state.user_session});
              } else {
                toggleModal();
                SendLogs({severity: '40000', message: 'POST createAccount API error: ' + JSON.stringify(result) + 'EmailID:'+state.username, userSession: state.user_session});
                SendMetrics({name: 'CreateAccount.Count.Metrics.Error', value: 1, userSession: state.user_session});
              }
            } else if(res.status >= 500){
              SendMetrics({name: 'CreateAccount.Count.Metrics.Error', value: 1, userSession: state.user_session});
              if(createAccountRetries === 3){
                setApiError();
              } else{
                setCreateAccountRetries(createAccountRetries + 1);
              }
            }
            SendMetrics({name: 'CreateAccount.Count.Metrics', value: 1, userSession: state.user_session});
            SendLogs({severity: '20000', message: 'Create Account API Status Code: '+ res.status + 'EmailID:'+state.username, userSession: state.user_session});
          }).catch(error => {
            SendMetrics({name:"CreateAccount.Latency", value: new Date() - start, userSession:state.user_session});
            console.log(error);
            SendLogs({severity: 40000, message: "POST createAccount API error: " + error.message + "EmailID:"+state.username, userSession:state.user_session});
            SendMetrics({name: 'CreateAccount.Count.Metrics', value: 1, userSession: state.user_session});
            SendMetrics({name:"CreateAccount.Count.Metrics.Fail", value:1, userSession:state.user_session});
          })
    }
  },[createAccountStatus.createAccountApi, createAccountRetries])

  const doClick = () => {
    if(createAccountStatus.checked) {
      updateCreateAccountStatus(createAccountStatus.checked, true);
    }
    SendAction({action: 'User clicked Start my free trial button', value: 'POST createAccount API called', userSession: state.user_session})
    SendLogs({severity: '20000', message: 'User clicked Start my free trial button, EmailID:'+state.username, userSession: state.user_session});
    navTrack('oci-signup', state.language, 's2-clicked-start-my-free-trial-button', 'finished-signup-process');
  }

  const translatedOrgName = state.country == 'MX' && _.isEmpty(state.selectedPromo) && state.defaultPromo.type === 'Standard' ? OrgNameList["mxOrgName"] : OrgNameList[state.countryInfo.tc.OrgName];

  const agreementCheckbox = () => {
    const index = _.findIndex(state.featureFlags, function (o) {
      return _.isEmpty(state.featureFlags) ? false : o.featureName === "sms";
    });

    const smsFeatureFlag = index !== -1 ? state.featureFlags[index].isActive : false;

    const isMobileNumberInvalid = _.isEmpty(state.phoneNumber) ? true : !state.validPhoneNumber;

    //Below cases when sms verification is Active and inActive:
    //1. Standard Promotion or both creditCardRequired and validationCodeRequired
    //2. ValidationCodeRequired and creditCard is not required
    //3. creditCardRequired and validationCode is not required
    //4. validationcode not required and creditcard is not required

    if(_.isEmpty(state.selectedPromo) || (state.selectedPromo.creditCardRequired && state.selectedPromo.validationCodeRequired)) {
      if(smsFeatureFlag) {
        return state.addressValidation || state.mobileValidation || _.isEmpty(state.paymentOptions) || checkbox
      } else {
        return state.addressValidation || isMobileNumberInvalid || _.isEmpty(state.paymentOptions) || checkbox
      }
    } else if(state.selectedPromo.validationCodeRequired && !state.creditCardRequired) {
      if(smsFeatureFlag) {
        return state.addressValidation || state.mobileValidation
      } else {
        return state.addressValidation || isMobileNumberInvalid 
      }
    } else if(state.selectedPromo.creditCardRequired && !state.validationCodeRequired) {
      return state.addressValidation || isMobileNumberInvalid || _.isEmpty(state.paymentOptions)
    } else {
      return state.addressValidation || isMobileNumberInvalid;
    }
  }
  
  return (
    <div className="agreementComponent">
      <div className="title6">
        {t('agreement.title')}
      </div>
      <RedwoodCheckbox
        checked={createAccountStatus.checked}
        disabled={agreementCheckbox()}
        onChange={() => {
          updateCreateAccountStatus(!(createAccountStatus.checked), false); 
          navTrack('oci-signup', state.language, 's2-checked-TnC-checkbox', 'Agreed-to-TnC')
        }}
      >
        <Trans i18nKey="agreement.termsAndConditions">By clicking <b>Start my free trial </b>, I agree to the terms and conditions of the 
          <a href={state.countryInfo.tc.URL} target='_blank' rel="noopener noreferrer"> Oracle Cloud Services Agreement V040119 for {{translatedOrgName}}</a>, (also available <a href="https://www.oracle.com/corporate/contracts/" target="_blank" rel="noopener noreferrer">here</a>)
          and this order including Service Description for Free Oracle Cloud Promotion Universal Credits -
          Part Number {_.isEmpty(state.selectedPromo) ? state.defaultPromo.partNumber : state.selectedPromo.partNumber}.
        </Trans>
      </RedwoodCheckbox>
      
      <RedwoodModal onClose={e=> closeModal()} show={show} title={t('agreement.errorTitle')} buttonName={t('agreement.tryMeButton')}>
        <p>{t('agreement.errorDialog1')}</p>
        <p><Trans i18nKey="agreement.errorDialog2"><a href={window.location.href} target='_blank' rel="noopener noreferrer">Refresh</a> and start the sign-up process over, this problem may be temporary.</Trans></p>
        <p><Trans i18nKey="agreement.errorDialog3">Otherwise, if the problem persists you can <a href="https://oc-cx-en.custhelp.com/app/chat/chat_launch" target='_blank' rel="noopener noreferrer">contact chat support</a> and we will make sure to get you through the sign-up process.</Trans></p>
      </RedwoodModal>     
    
      <Button type="solid" id="startMyTrialBtn" disabled={!createAccountStatus.checked} onClick={e => doClick(e)} text={t('agreement.startMyFreeTrial')} loading={loading}/>
    </div>

  )
}

export default AgreementComponent;
